import React, { useCallback, useEffect, useState } from "react";
import { Layout, Card, Button, Row, Col, Typography, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import actions from "../redux/examdashboard/actions";
import config from "../Services/apiEndPoints";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { Header } = Layout;

export default function PreviousExamsList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const studentId = localStorage.getItem("Student_Id");
  const handleStart = () => {};
  const { examdashboardDetails, isFetching } = useSelector(
    (state) => state.getDetailsReducer
  );

  const getDetails = useCallback(() => {
    dispatch(
      actions.getDetails(`${config.examdashboard}?studentId=${studentId}`)
    );
  }, [dispatch, studentId]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);



  return (
    <div>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate("/dashboard")}
        style={{width:"50px",marginTop:'15px',marginLeft:'8px'}}
      >
      </Button>
      <Row gutter={16} justify="center" style={{ padding: "16px" }}>
        {examdashboardDetails?.previous_examination_data?.map((exam) => (
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            key={exam.id}
            style={{ marginBottom: 16 }}
          >
            <Card
              title={exam.exam_name}
              bordered={false}
              style={{
                width: "100%",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
              }}
            >
              <Row gutter={16} align="middle">
                <Col span={16}>
                  <Typography.Title level={5}>
                    {exam?.exam_description}
                    <br />
                    {exam?.question_paper_details?.title}
                    <br />
                    Subject:{exam?.question_paper_details?.subject}
                  </Typography.Title>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                  <Typography.Paragraph>
                    Date:{" "}
                    {exam?.tests?.exam_start_time &&
                      new Date(exam?.tests?.exam_start_time).toLocaleString()}
                  </Typography.Paragraph>
                  <Typography.Paragraph>
                    Time:{" "}
                    {exam?.tests?.exam_end_time &&
                      new Date(exam?.tests?.exam_end_time).toLocaleString()}
                  </Typography.Paragraph>
                  <Button
                    type="primary"
                    disabled={exam.disable}
                    onClick={() => {
                      localStorage.setItem("examId", exam?._id);
                      localStorage.setItem(
                        "question_paper_id",
                        exam?.tests?.question_paper?.question_paper_id
                      );
                      localStorage.setItem(
                        "exam_end_time",
                        exam?.tests?.exam_end_time)
                      navigate(`/dashboard/examResults/id=${studentId}`);
                    }}
                    style={{ width: "100%", marginTop: "10px" }} // Optional: margin for spacing
                  >
                    View Result
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
